import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

/**
 * Section title — calm hierarchy (replaces legacy orange ribbon).
 */
export function SectionTitle({ children, className = "" }) {
  return (
    <div className={`mt-10 first:mt-0 ${className}`}>
      <h2 className="text-base font-semibold tracking-tight text-secondary">
        {children}
      </h2>
      <div className="mt-3 h-px w-full max-w-md bg-border" />
    </div>
  );
}

/** @deprecated Use SectionTitle; kept for backward compatibility */
const Gap = (props) => {
  const className = props.className === undefined ? "" : props.className;
  return <SectionTitle className={className}>{props.children}</SectionTitle>;
};

export default Gap;

export const GapV2 = ({
  className = "",
  children,
  header,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  const toggleOpen = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [children, isOpen]);

  return (
    <div
      className={`flex w-full flex-col ${className} mb-6 mt-8 first:mt-0`}
    >
      <button
        type="button"
        className="flex w-full max-w-2xl items-center justify-between rounded-lg border border-border bg-surface px-4 py-3 text-left text-sm font-semibold text-secondary shadow-xs transition-colors duration-200 hover:bg-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
        onClick={toggleOpen}
      >
        <span>{header || "Section"}</span>
        {isOpen ? (
          <FaChevronUp className="h-4 w-4 text-muted" />
        ) : (
          <FaChevronDown className="h-4 w-4 text-muted" />
        )}
      </button>
      <div
        className="overflow-hidden transition-[max-height] duration-200 ease-in-out"
        style={{
          maxHeight: `${contentHeight}px`,
        }}
      >
        <div ref={contentRef} className="pt-4">
          {children}
        </div>
      </div>
    </div>
  );
};
